import { faBullseye } from "@fortawesome/free-solid-svg-icons";

const collections = [
  {
    backgroundImg:
      "https://lh3.googleusercontent.com/0sWEU9cuiDWuVCllftjTfArgoNurkK1fBn0BL9BEGBl6r6WQyDnxwcd3kZKMK9K22oxBCXq75gs1Ndm0tQNCT5MpZTEjoIma99FCEg=h600",
    contractUrl: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
    collectionName: "Project Arowana Prime",

    details: {
      isVerified: true,
      category: ["art", "top"],
      blockchain: "ethereum"
    },

    creator: {
      name: "ArowanaHub",
      isVerified: false,
      avatar:
        "https://lh3.googleusercontent.com/deRCtXoJ0-6K5AaHZsdsBNP_pkgC98PXHHQrfDczO786oZMGnxghXG6XtTU2fREUvFuV4IvIKnbLroRlIoqE1xwv7lpQV87RzhhtsA=s130",
      url: "",
      joinDate: "02.2022",
    },

    stats: {
      items: 20,
      owners: 2,
      currency: "ETH",
      floorPrice: 0.25,
      totalSales: 0.13, //i.e. volume traded
    },

    NFTs: {},

    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio dolores perferendis soluta illo quis magnam, accusamus doloremque vel facere eligendi cumque voluptatum voluptatem quo quia, laudantium totam asperiores sapiente sunt.",

    activity: {
      salesHistory: [
        {
          artwork: {
            img: "",
            name: "",
          },
          from: "",
          to: "",
          type: "",
          price: {
            currency: "",
            amount: "",
          },
          date: "",
        },
      ],
    },
  },
  {
    backgroundImg:
      "https://lh3.googleusercontent.com/GqVjY5pCGyHzfo5zYl6ocRbdEGGwZPgXcmyKCcPMhepkZATScV6H_iKlGvnkyfgLE_QdpFLHUeYhzMCHPGMGpKwKXuVL4vbuFMPD0A=h600",
    contractUrl: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
    collectionName: "MoonCats",

    details: {
      isVerified: true,
      category: ["sports"],
      blockchain: "solana"
    },

    creator: {
      name: "ponderware",
      isVerified: true,
      avatar:
        "https://lh3.googleusercontent.com/0Dc4CsBHSRrkQc5W0-bTWOn2fXnqi1Hldf92yAmSZCOhIolUyWs4wUuMJ52SEL8e3kk4U0Z76RQlJxAzM48B_hs7XKgi7Xxg9DfpAA=s0",
      url: "",
      joinDate: "04.2021",
    },

    stats: {
      items: 19100,
      owners: 5800,
      currency: "ETH",
      floorPrice: 0.295,
      totalSales: 18100, //i.e. volume traded
    },

    NFTs: {},

    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio dolores perferendis soluta illo quis magnam, accusamus doloremque vel facere eligendi cumque voluptatum voluptatem quo quia, laudantium totam asperiores sapiente sunt.",

    activity: {
      salesHistory: [
        {
          artwork: {
            img: "",
            name: "",
          },
          from: "",
          to: "",
          type: "",
          price: {
            currency: "",
            amount: "",
          },
          date: "",
        },
      ],
    },
  },
  {
    backgroundImg:
      "https://lh3.googleusercontent.com/T27G8XyEu60YYIz1iwTNA3eSzlm1oXoyKxuuVYJLTCoBKvl0Tk0KzWYSXXorfWAgmhfJvnV4SwVg6mu-S62X9wBesRFeHF_wHbYeeL0=h600",
    contractUrl: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
    collectionName: "Asprey Bugatti La Voiture Noire Collection",

    details: {
      isVerified: true,
      category: ["sports"],
      blockchain: "solana"
    },

    creator: {
      name: "Asprey",
      isVerified: false,
      avatar:
        "https://lh3.googleusercontent.com/PdVUWMc9-kmOuQ24iqoMrFm2rOU1qLLNjV5v5r6QWvTcCAKdVnSXdios-mKwnrswSexdtM05e0DiQK0cxiE15nGwpmrwFF-wpFA5jg=s130",
      url: "",
      joinDate: "03.2022",
    },

    stats: {
      items: 261,
      owners: 214,
      currency: "ETH",
      floorPrice: 10.4,
      totalSales: 581, //i.e. volume traded
    },

    NFTs: {},

    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio dolores perferendis soluta illo quis magnam, accusamus doloremque vel facere eligendi cumque voluptatum voluptatem quo quia, laudantium totam asperiores sapiente sunt.",

    activity: {
      salesHistory: [
        {
          artwork: {
            img: "",
            name: "",
          },
          from: "",
          to: "",
          type: "",
          price: {
            currency: "",
            amount: "",
          },
          date: "",
        },
      ],
    },
  },
  {
    backgroundImg:
      "https://lh3.googleusercontent.com/QLXgRCyiPeUEO9JXyS2P9yyZhVjgqb9oHRMsPuXgeKhybQ8fWPbY4MpBjFaAQ56zeDMq9DQSVsVmC-xod9-IMfQVeygdqsgE1ogyGgc=h600",
    contractUrl: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
    collectionName: "KlayCity District",

    details: {
      isVerified: false,
      category: ["art"],
      blockchain: "solana"
    },

    creator: {
      name: "KLAYCITY_OFFICIAL",
      isVerified: true,
      avatar:
        "https://lh3.googleusercontent.com/deTMyhaY7MxFisD4JS6bSl1ZzWto_oxe7asa6jaKJ7ge4HgnLttfuW-vgPNDpKNXDOpyvDfb6oHsNSUrcQH6cdJ97N00vRD9GgQOHjE=s130",
      url: "",
      joinDate: "01.2022",
    },

    stats: {
      items: 2000,
      owners: 30,
      currency: "SOL",
      floorPrice: 1.8,
      totalSales: 6700000, //i.e. volume traded
    },

    NFTs: {},

    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio dolores perferendis soluta illo quis magnam, accusamus doloremque vel facere eligendi cumque voluptatum voluptatem quo quia, laudantium totam asperiores sapiente sunt.",

    activity: {
      salesHistory: [
        {
          artwork: {
            img: "",
            name: "",
          },
          from: "",
          to: "",
          type: "",
          price: {
            currency: "",
            amount: "",
          },
          date: "",
        },
      ],
    },
  },
];

export default collections;
